import { RatingStars } from '../../../shared/components/RatingStars';
import smallAvatar1 from '../../../shared/assets/img/small-avatars/small-avatar-1.svg';

interface TestimonialCardProps {
    name: string;
    title: string;
    review: string;
}

export const TestimonialCard = ({ name, title, review }: TestimonialCardProps) => {
    return (
        <div className='bg-osGrey-5 rounded-3xl p-5 flex flex-col gap-4 text-left'>
            <div className='flex items-center justify-between gap-2'>
                <RatingStars />
                <div className='flex items-center gap-1 text-osBlack text-sm font-semibold'>
                    <img
                        src={smallAvatar1}
                        alt='small-avatar-1'
                        className='w-6 h-6'
                    />
                    <span className='text-osGrey-2 text-xs font-semibold'>By {name}</span></div>
            </div>
            <div className='text-osBlack font-semibold'>{title}</div>
            <div className='text-osGrey-2 text-sm'>{review}</div>
        </div>
    );
};